import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMagic = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m24.554 10.752 3.498-3.82h-4.269l-2.6-4.814-2.6 4.815h-4.236l3.466 3.82-1.476 5.36 4.847-2.568 4.846 2.567zm5.2-5.552.673 1.7-3.948 4.334 1.637 5.938-1.316 1.316-5.617-2.985-5.135 2.728L3.242 32l-1.67-1.605 12.84-13.77 1.476-5.423L11.94 6.9l.674-1.701h4.943L20.349 0h1.669l2.792 5.2z" /></svg>;
export default SvgMagic;